var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAhmsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 191 153",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-306.212,-272.642)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.491,
    y: 79.191,
    width: 45.811,
    height: 9.149,
    style: {
      fill: "rgb(5,79,163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-306.212,-272.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.025,87.101L77.481,87.101L79.819,80.429L82.433,80.429L84.772,87.101L82.227,87.101L82.02,86.276L80.232,86.276L80.025,87.101ZM81.47,84.557L81.195,83.387C81.126,83.112 81.126,82.837 81.057,82.493L80.989,82.493L80.507,84.557L81.47,84.557Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-306.212,-272.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.666,80.429L88.005,80.429L88.005,82.699L89.449,82.699L89.449,80.429L91.788,80.429L91.788,87.101L89.449,87.101L89.449,84.763L88.005,84.763L88.005,87.101L85.666,87.101L85.666,80.429Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-306.212,-272.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.645,80.429L96.121,80.429L97.016,83.937L97.084,83.937C97.153,83.662 97.153,83.318 97.222,83.043L97.979,80.429L100.455,80.429L101.487,87.101L99.217,87.101L98.873,83.456L98.804,83.456C98.804,83.662 98.735,83.937 98.667,84.144L97.703,87.101L96.328,87.101L95.433,84.281C95.365,84.006 95.296,83.731 95.296,83.456L95.227,83.456C95.227,83.731 95.227,84.006 95.158,84.281L94.883,87.101L92.545,87.101L93.645,80.429Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-306.212,-272.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.926,87.446C104.032,87.446 103,87.239 102.175,86.827L102.931,84.763L103.069,84.9C103.55,85.244 104.101,85.588 104.72,85.588C104.995,85.588 105.407,85.451 105.407,85.107C105.407,84.831 105.064,84.763 104.788,84.694L104.307,84.625C103.275,84.419 102.381,83.869 102.381,82.699C102.381,81.048 103.963,80.085 105.476,80.085C106.302,80.085 107.058,80.292 107.746,80.705L107.058,82.562C106.646,82.218 106.095,82.011 105.545,82.011C105.339,82.011 104.995,82.08 104.995,82.355C104.995,82.63 105.339,82.699 105.545,82.699L106.095,82.837C107.196,83.112 108.021,83.662 108.021,84.9C108.021,86.62 106.439,87.446 104.926,87.446Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-306.212,-272.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.704,87.101L108.228,87.101L110.498,80.36L113.111,80.36L115.519,87.101L112.974,87.101L112.768,86.276L110.91,86.276L110.704,87.101ZM112.286,84.694L112.011,83.525C111.942,83.181 111.942,82.906 111.874,82.63L111.805,82.63L111.323,84.694L112.286,84.694Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-306.212,-272.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.026,78.228C106.026,78.228 103.206,72.725 96.603,72.725C92.957,72.725 89.312,74.514 87.11,78.228L79.2,78.228C81.539,70.799 88.417,65.434 96.603,65.434C104.788,65.434 111.667,70.799 114.006,78.228L106.026,78.228Z",
    style: {
      fill: "rgb(253,183,39)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-306.212,-272.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.026,89.303C106.026,89.371 103.206,94.805 96.603,94.805C92.957,94.805 89.243,93.017 87.11,89.303L79.131,89.303C81.47,96.732 88.417,102.097 96.603,102.097C104.72,102.097 111.667,96.732 114.006,89.303L106.026,89.303Z",
    style: {
      fill: "rgb(253,183,39)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhmsa);
export default __webpack_public_path__ + "static/media/Ahmsa.3c037482e01e8af2742033e75a53c43a.svg";
export { ForwardRef as ReactComponent };